import { useEffect, useState } from 'react'
import '../styles/CodeLineage.scss'
import SearchableDropdown from '../components/SearchableDropdown'
import configureIcon from '../assets/png/ico_configure.png'
import downloadIcon from '../assets/png/ico_download.png'
import { advLineageChat, getRepositoryDetails } from '../api/codeLineage.api'
import { useFetch } from '../hooks/useFetch'
import StatusModal from '../components/StatusModal'
import { useOverlaySidebar } from "../context/OverlaySidebarContext";
import { IoIosSearch } from "react-icons/io";
import { IoIosAddCircleOutline } from "react-icons/io";
import { IoIosRemoveCircleOutline } from "react-icons/io";
import { useNavigate } from 'react-router-dom'
import ChatBot from '../components/ChatBot'
import InfoModal from '../components/InfoModal'
import TraceModal from '../components/TraceModal';
import { Tooltip } from 'primereact/tooltip';
import { LiaHandPointUp } from 'react-icons/lia'
import PageLoader from '../components/PageLoader'


function AdvancedCodeLineage() {
    const navigate = useNavigate();
    const [repoList, setRepoList] = useState([])
    const [selectedRepo, setSelectedRepo] = useState(null)
    const { toggleOverlay, setOnCloseCallback } = useOverlaySidebar();
    const { data: repoResponse, loading, error } = useFetch(getRepositoryDetails, []);
    const [messages, setMessages] = useState([]);
    const [input, setInput] = useState("");
    const [loadingChat, setLoadingChat] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [selectedGraphUrl, setSelectedGraphUrl] = useState(null);
    const [selectedGraphUrlStrOrg, setSelectedGraphUrlStrOrg] = useState(null);
    const [zoom, setZoom] = useState(1);
    // const [expanded, setExpanded] = useState(false);
    const [open, setOpen] = useState(false);
    const [opentrace, setOpentrace] = useState(false);
    const [traceDataLog, setTraceDataLog] = useState([]);

    const [pageLoader, setPageLoader] = useState(false);
    const [modal, setModal] = useState({
        open: false,
        type: "success",
        message: ""
    });
    useEffect(() => {
        const storedData = JSON.parse(localStorage.getItem("chatDataAdvancedCL"));
        // console.log('storedData', storedData);
        if (storedData) {
            setMessages(storedData.messages || []);
            setSelectedRepo(storedData.selectedRepo)
            if (storedData && storedData.messages && storedData.messages.length > 0) {
                const item = storedData?.messages[storedData?.messages.length - 1];
                setSelectedId(item.id);
                let htmlString = item?.answerGraphUrlString;
                if (!htmlString) {
                    setSelectedGraphUrl(null);
                    return
                }
                setSelectedGraphUrlStrOrg(item?.answerGraphUrlString)
                const generateHTMLURL = processGraphHtml(htmlString);
                setSelectedGraphUrl(generateHTMLURL);
                setTraceDataLog(item.traceLog);
            }
        } else {
            setMessages([]);
            setOpen(true);
            localStorage.removeItem("chatDataAdvancedCL");
        }

    }, []);

    useEffect(() => {
        if (repoResponse) {
            setRepoList(repoResponse.data)
        }

    }, [repoResponse])

    useEffect(() => {
        setPageLoader(loading)

    }, [loading]);

    useEffect(() => {
        if (error) {
            setModal({
                open: true,
                type: "error",
                message: "Failed to load repositories."
            });
        }
    }, [error]);

    setOnCloseCallback(() => {
        reloadApi();
    });

    const reloadApi = async () => {
        try {
            const response = await getRepositoryDetails();
            if (response.status === 200) {
                const resData = response.data?.data
                setRepoList(resData);
            }
            else {
                setModal({
                    open: true,
                    type: "error",
                    message: response.data.data.message
                });
            }
        } catch (error) {

        }
    };

    const onRepoSelect = (repo) => {
        setSelectedRepo(repo);
        setSelectedGraphUrl(null);
    };

    useEffect(() => {
        if (selectedRepo && messages && messages.length > 0) {
            const chatData = {
                selectedRepo,
                messages,
                timestamp: new Date().toISOString(),
            };
            localStorage.setItem("chatDataAdvancedCL", JSON.stringify(chatData));
        }
    }, [selectedRepo, messages]);

    const sendUserMessage = async () => {
        if (!input.trim()) return;
        const userMsg = {
            id: `user-${Date.now()}`,
            type: "user",
            content: input,
            timestamp: new Date().toISOString(),
        };
        setMessages(prev => [...prev, userMsg]);
        setInput("");
        setLoadingChat(true);
        try {
            const payload = { RepoId: selectedRepo?.repo_id, user_input: input };
            const response = await advLineageChat(payload);
            if (response.status === 200) {
                const resData = response?.data?.data;

                setSelectedGraphUrlStrOrg(resData?.answerGraphUrlString)
                const fullReply = resData?.answer || "No answer provided.";
                typeBotReply(
                    {
                        text: fullReply,
                        answerGraphUrl: resData?.answerGraphUrl || null,
                        answerGraphUrlString: resData?.answerGraphUrlString || null,
                        traceLog: resData?.agent_trace || null
                    },
                    (botId, msg) => {
                        setSelectedId(botId);
                        let htmlString = msg?.answerGraphUrlString;
                        if (!htmlString) {
                            setSelectedGraphUrl(null);
                            return false
                        }
                        const generateHTMLURL = processGraphHtml(htmlString);
                        setSelectedGraphUrl(generateHTMLURL);
                        setTraceDataLog(msg.traceLog);
                    }
                );
            } else {
                typeBotReply({
                    text: response.data.data?.message,
                    answerGraphUrl: null,
                    answerGraphUrlString: null
                });
            }
        } catch (err) {
            typeBotReply({
                text: 'Something went wrong. Please try again.',
                answerGraphUrl: null,
                answerGraphUrlString: null
            });
        } finally {
            setLoadingChat(false);
        }
    };

    const typeBotReply = (
        { text, answerGraphUrl, answerGraphUrlString, traceLog },
        onComplete
    ) => {
        let index = 0;

        const botId = `bot-${Date.now()}`;
        const botMsg = {
            id: botId,
            type: "bot",
            content: "",
            timestamp: new Date().toISOString(),
            answerGraphUrl,
            answerGraphUrlString,
            traceLog
        };

        setMessages(prev => [...prev, botMsg]);
        const interval = setInterval(() => {
            index++;
            setMessages(prev =>
                prev.map(msg =>
                    msg.id === botId
                        ? { ...msg, content: text.slice(0, index) }
                        : msg
                )
            );
            if (index >= text.length) {
                clearInterval(interval);
                // 🔘 Only call if provided
                if (typeof onComplete === "function") {
                    onComplete(botId, botMsg);
                }
            }
        }, 20);
    };

    const chatClick = (msg) => {
        if (msg?.type !== "user" && msg?.answerGraphUrlString) {
            // setGraphUrl(msg.answerGraphUrl);
            setSelectedId(msg.id);
            let htmlString = msg?.answerGraphUrlString;
            if (!htmlString) {
                return false
            }
            setSelectedGraphUrlStrOrg(htmlString)
            const generateHTMLURL = processGraphHtml(htmlString);
            setSelectedGraphUrl(generateHTMLURL);
        } else {
            setSelectedId(msg.id);
            setSelectedGraphUrl(null)
        }


        if (msg?.type !== "user" && msg?.traceLog) {
            setSelectedId(msg.id);
            setTraceDataLog(msg.traceLog)
        }
        else {
            setSelectedId(msg.id);
            setTraceDataLog([])
        }
    };

    const processGraphHtml = (htmlString) => {
        if (!htmlString) {
            return false;
        }
        htmlString = htmlString.replace(/interaction\":\s*{[^}]*}/,
            `interaction": {
                dragNodes: true,
                dragView: true,
                zoomView: true,
                hideEdgesOnDrag: false,
                hideNodesOnDrag: false
                }`
        );
        const customCSS = `
                <style>
                #mynetwork {
                    width: 100% !important;
                    height: 98vh !important;
                    background-color: transparent;
                    border: none !important;
                    position: relative;
                    float: left;
                    padding:0 !important;
                }
                .card {
                    border: none !important;
                } 
                </style>
            `;
        htmlString = htmlString.replace("</head>", `${customCSS}</head>`);
        const blob = new Blob([htmlString], { type: "text/html" });
        const iframeUrl = URL.createObjectURL(blob);
        return iframeUrl;
    };


    // const downloadHtml = () => {
    //     const link = document.createElement("a");
    //     link.href = selectedGraphUrl;
    //     link.download = "code_lineage_graph.html"; // rename if you want
    //     document.body.appendChild(link);
    //     link.click();
    //     document.body.removeChild(link);
    // };

    const downloadHtml = () => {
        const repoName = selectedRepo?.repo_name || '';
        const fullHtml = `
            <!DOCTYPE html>
            <html>
            <head>
                <meta charset="UTF-8" />
                <title>${repoName} Graph</title>
                  <style>
                    .col {
                        display: flex;
                        align-items: center;
                        font-family: sans-serif;
                        font-size: 10px;
                        margin: 4px 0;
                    }
                    .col::before {
                        content: "";
                        display: inline-block;
                        width: 34px;
                        height: 10px;
                        margin-right: 8px;
                    }
                    .bronze::before {
                        background-color: #cd7f32; /* bronze */
                    }
                    .silver::before {
                        background-color: #c0c0c0; /* silver */
                    }
                    .gold::before {
                        background-color: #ffd700; /* gold */
                    }
                    </style>
            </head>
            <body>
            <div style="margin:.5rem 1rem; display:flex">
             <div>
                <span style="color: #FD5108; font-weight: bold;font-family: sans-serif;font-size: 12px;">Repository :</span>
                <span style="color: #464646;font-family: sans-serif;font-size: 12px;">${repoName}</span> 
            </div>
            <div style="display: flex;margin-left: 10%; width:350px" >
                <div class="col bronze">Bronze Layer</div>
                <div class="col silver">Silver Layer</div>
                <div class="col gold">Gold Layer</div>
            </div>
            </div>
            ${generateHTMLGraphDownload(selectedGraphUrlStrOrg)}
            </body>
            </html>
        `;

        const blob = new Blob([fullHtml], { type: "text/html" });
        const url = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = `${repoName}.html`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };


    const generateHTMLGraphDownload = (htmlString) => {
        if (!htmlString) {
            return false
        }
        htmlString = htmlString.replace(
            /interaction\":\s*{[^}]*}/,
            `interaction": {
                dragNodes: true,
                dragView: true,
                zoomView: true,
                hideEdgesOnDrag: false,
                hideNodesOnDrag: false
            }`
        );
        const customCSS = `
                    <style>
                    #mynetwork {
                        width: 100% !important;
                        height: 90vh !important;
                        background-color: transparent;
                        border: 1px solid #d8d4d4 !important;
                        position: relative;
                        float: left;
                    }
                    .card {
                        border: none !important;
                        padding: 0rem 1rem
                    } 
                    </style>
                    `;
        const finalString = htmlString.replace("</head>", `${customCSS}</head>`);
        return finalString
    }

    const clearChat = () => {
        setSelectedRepo(null)
        setSelectedId(null)
        setSelectedGraphUrl(null)
        setMessages([])
        localStorage.removeItem('chatDataAdvancedCL')

    }
    return (
        <>
            <section className="clTopSection d-flex align-items-center">
                <div className="row w-100">
                    <div className="col-8 col-xxl-9 d-flex align-items-center">
                        <div className="row w-100">
                            <div className="col d-flex align-items-center justify-content-start">
                                {/* <label className='clTextAvd'>Advanced Lineage Studio</label> */}
                                <div className='dropDownSection advDropdownDiv'>
                                    <label className='labelText'>Select repository</label>
                                    <SearchableDropdown
                                        options={repoList}
                                        label="repo_name"
                                        id="repo_id"
                                        selectedVal={selectedRepo}
                                        handleChange={(value) => {
                                            localStorage.removeItem('chatDataAdvancedCL')
                                            setMessages([])
                                            setSelectedGraphUrl(null)
                                            setSelectedId(null)
                                            onRepoSelect(value)
                                        }}
                                        placeholder='Please select'
                                        showClear={false}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-4 col-xxl-3 d-flex align-items-center justify-content-between p-0">
                        {/* <span className='clOptionText' onClick={() => clearChat()}>
                            <i className='ClearIcon2'></i> Clear
                        </span> */}
                        <span className='clOptionText' onClick={() => downloadHtml()}>
                            <img src={downloadIcon} alt="download" className='clOptionIcon' />Download
                        </span>
                        <span className='clOptionText' onClick={() => navigate('/lineage-studio')}>
                            <i className="CLIcon"></i>Basic
                        </span>
                        <span className='clOptionText' onClick={toggleOverlay}>
                            <img src={configureIcon} alt="configure" className='clOptionIcon' />Configure
                        </span>
                        <span className='clOptionText' onClick={() => setOpen(true)}>
                            <i className='IconHelp' />
                        </span>
                    </div>
                </div>
            </section>
            <section className='graphSection2'>
                <div className="row w-100 h-100">
                    <div
                        // className={`transition-col ${expanded ? "col-5" : "col-11"}`}
                        className="col-5"
                    >
                        <ChatBot
                            messages={messages}
                            inputValue={input}
                            onInputChange={setInput}
                            onSend={sendUserMessage}
                            onMessageClick={chatClick}
                            loading={loadingChat}
                            disabled={!selectedRepo}
                            selectedId={selectedId}
                            // disabledText={'Please select a repository to enable chat.'}
                            disabledText={<>
                                <div className='disabledChatMessage'>
                                    {/* <i className='LeftHandIcon'></i> */}
                                    <LiaHandPointUp className="bottomHand" />
                                    <p style={{ marginTop: '1.5rem' }}> Please select a repository <br />  to enable chat.</p>
                                </div>
                            </>}
                        // blankText={'I’m here to help you understand your code lineage, dependencies, and data flow. What’s your question?'}
                        />
                    </div>
                    <div
                        className="col-7"
                    >
                        <div className="graphImageBlock">
                            {messages && messages.length > 0 &&
                                <>
                                    <Tooltip target=".clearIcon" />
                                    <span className='clearIcon'
                                        onClick={() => clearChat()}
                                        data-pr-tooltip="Clear chats"
                                        data-pr-position="left"
                                    >
                                        <i className='ClearIcon3'></i>
                                    </span>
                                </>
                            }
                            {/* {(messages && messages.length === 0) &&
                                <div className='traceText'>
                                    <i className='LeftHandIcon'></i>
                                    You have not asked a question <br /> yet on the left pane.
                                </div>
                            } */}
                            {(selectedGraphUrl && selectedId) &&
                                <div className="graphWrapper">
                                    <div className='colorInfoSection'>
                                        <div className="row">
                                            <div className="col bronze">Bronze Layer</div>
                                            <div className="col silver">Silver Layer</div>
                                            <div className="col gold">Gold Layer</div>
                                            <div className="col unknown">Unknown</div>
                                        </div>
                                    </div>
                                    <iframe
                                        src={selectedGraphUrl}
                                        style={{
                                            // width: "100%",
                                            // height: "70vh",
                                            border: "none",
                                            transform: `scale(${zoom})`,
                                            transformOrigin: "0 0",
                                        }}
                                        title="Graph Viewer"
                                        className="graphIframe"
                                    />
                                </div>
                            }
                            {(!selectedGraphUrl && selectedId) &&
                                <span className='notGraphText'>Unable to display a graph for this input. Consider rephrasing <br /> or providing more details</span>
                            }
                            {(selectedGraphUrl && selectedId) &&
                                <div className='zoomSection'>
                                    <IoIosAddCircleOutline
                                        onClick={() => setZoom(prev => prev + 0.1)}
                                        className='zoomIcon'
                                    /> <br />
                                    <IoIosRemoveCircleOutline
                                        onClick={() => setZoom(prev => Math.max(0.1, prev - 0.1))}
                                        className='zoomIcon'
                                    />
                                </div>
                            }
                            <button className='traceButton'
                                onClick={() => setOpentrace(true)}
                                disabled={!selectedId}
                            >
                                <IoIosSearch style={{ fontSize: '35px' }} />TRACE
                            </button>
                        </div>
                    </div>

                </div>
            </section>
            <StatusModal
                open={modal.open}
                type={modal.type}
                message={modal.message}
                onClose={() => setModal({ ...modal, open: false })}
                autoClose={false}
                duration={5000}
            />
            <InfoModal
                open={open}
                onClose={() => setOpen(false)}
                heading={<>
                    Please select a project type and then choose a repository from the top dropdown menus.
                    After that, enter your questions to view the detailed insights.
                </>}
                config='Configure lineage studio and add repository'
                download='Download detailed insights'
                codelineage='Basic lineage studio insights'
                title='Advanced lineage studio help'
                type={3}
            />
            <PageLoader show={pageLoader} />
            <TraceModal
                open={opentrace}
                onClose={() => setOpentrace(false)}
                title='Reasoning and Execution log'
                tracedata={traceDataLog}
                type={1}
            />
        </>
    )
}
export default AdvancedCodeLineage
